var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: (_vm.appName || "小程序") + " · 短信配置",
        visible: _vm.visible,
        direction: "rtl",
        size: "680px",
        "append-to-body": "",
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "drawer-content",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.config,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "短信服务状态：" } },
                [
                  _c("el-switch", {
                    attrs: { "active-text": "开启", "inactive-text": "关闭" },
                    model: {
                      value: _vm.config.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "enabled", $$v)
                      },
                      expression: "config.enabled",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "tip switch-tip" }, [
                    _vm._v("关闭后保存设置，该小程序停止短信发送"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "短信服务商：", prop: "provider" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleProviderChange },
                      model: {
                        value: _vm.config.provider,
                        callback: function ($$v) {
                          _vm.$set(_vm.config, "provider", $$v)
                        },
                        expression: "config.provider",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "TENCENT" } }, [
                        _vm._v("腾讯云"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "ALIYUN" } }, [
                        _vm._v("阿里云"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "使用全局账号：" } },
                [
                  _c("el-switch", {
                    on: { change: _vm.clearConfigValidate },
                    model: {
                      value: _vm.config.useGlobal,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "useGlobal", $$v)
                      },
                      expression: "config.useGlobal",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "开启后使用系统配置中的当前服务商账号，下面的账号信息仅供查看。"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.config.provider === "TENCENT"
                        ? "腾讯云账号配置"
                        : "阿里云账号配置"
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.config.provider === "TENCENT"
                        ? "SecretId："
                        : "AccessKey ID：",
                    prop: "currentAccessKeyId",
                  },
                },
                [
                  _vm.config.useGlobal
                    ? _c("el-input", {
                        attrs: {
                          value: _vm.displayAccount.accessKeyId,
                          disabled: "",
                        },
                      })
                    : _c("el-input", {
                        attrs: { placeholder: "请输入访问密钥ID" },
                        model: {
                          value: _vm.currentAccount.accessKeyId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.currentAccount,
                              "accessKeyId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "currentAccount.accessKeyId",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.config.provider === "TENCENT"
                        ? "SecretKey："
                        : "AccessKey Secret：",
                    prop: "currentAccessKeySecret",
                  },
                },
                [
                  _vm.config.useGlobal
                    ? _c("el-input", {
                        attrs: {
                          value: _vm.displayAccount.accessKeySecret,
                          disabled: "",
                        },
                      })
                    : _c("el-input", {
                        attrs: { placeholder: "请输入访问密钥Secret" },
                        model: {
                          value: _vm.currentAccount.accessKeySecret,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.currentAccount,
                              "accessKeySecret",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "currentAccount.accessKeySecret",
                        },
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "****** 表示密钥已经配置；测试或保存时会继续使用原密钥。"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.config.provider === "TENCENT"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "SmsSdkAppId：",
                        prop: "currentSdkAppId",
                      },
                    },
                    [
                      _vm.config.useGlobal
                        ? _c("el-input", {
                            attrs: {
                              value: _vm.displayAccount.sdkAppId,
                              disabled: "",
                            },
                          })
                        : _c("el-input", {
                            attrs: { placeholder: "请输入腾讯云短信应用ID" },
                            model: {
                              value: _vm.currentAccount.sdkAppId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentAccount,
                                  "sdkAppId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "currentAccount.sdkAppId",
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "短信签名：", prop: "currentSignName" } },
                [
                  _vm.config.useGlobal
                    ? _c("el-input", {
                        attrs: {
                          value: _vm.displayAccount.signName,
                          disabled: "",
                        },
                      })
                    : _c("el-input", {
                        attrs: { placeholder: "请输入已审核通过的短信签名" },
                        model: {
                          value: _vm.currentAccount.signName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.currentAccount,
                              "signName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "currentAccount.signName",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v("测试发送"),
          ]),
          _vm._v(" "),
          _c("el-alert", {
            staticClass: "mb20",
            attrs: {
              title:
                _vm.config.provider === "TENCENT"
                  ? "腾讯云模板参数按顺序填写 JSON 数组"
                  : "阿里云模板参数填写 JSON 对象，键名必须与模板变量一致",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "testForm",
              attrs: {
                model: _vm.testForm,
                rules: _vm.testRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "测试手机号：", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "11",
                      placeholder: "请输入11位中国大陆手机号",
                    },
                    model: {
                      value: _vm.testForm.phone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.testForm,
                          "phone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "testForm.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.config.provider === "TENCENT"
                        ? "腾讯模板Code："
                        : "阿里模板Code：",
                    prop: "templateCode",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入审核通过的短信模板Code" },
                    model: {
                      value: _vm.testForm.templateCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.testForm,
                          "templateCode",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "testForm.templateCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板参数：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder:
                        _vm.config.provider === "TENCENT"
                          ? '["1234"]'
                          : '{"code":"1234"}',
                    },
                    model: {
                      value: _vm.testForm.templateParams,
                      callback: function ($$v) {
                        _vm.$set(_vm.testForm, "templateParams", $$v)
                      },
                      expression: "testForm.templateParams",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("无模板变量时可以留空。"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.testing,
                        disabled: !_vm.config.enabled,
                      },
                      on: { click: _vm.sendTest },
                    },
                    [_vm._v("\n          发送测试短信\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "drawer-footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.save },
            },
            [_vm._v("保存配置")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }